var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("p", { staticClass: "comment__item__author" }, [
    _c(
      "a",
      {
        staticClass: "comment__item__author__link",
        attrs: {
          href: _vm.author.profile.vanity
            ? "/u/" + _vm.author.profile.vanity
            : null
        }
      },
      [
        _c("span", {
          staticClass: "comment__item__author__picture",
          style: _vm.backgroundProfileImageStyle
        }),
        _vm._v(" "),
        _c("span", { staticClass: "comment__item__author__name" }, [
          _vm._v(_vm._s(_vm.authorName))
        ])
      ]
    ),
    _vm._v(" "),
    _c("span", { staticClass: "bullet" }, [_vm._v("•")]),
    _vm._v(" "),
    _c("span", { staticClass: "comment__item__meta" }, [
      _vm._v(_vm._s(_vm._f("processDate")(_vm.comment.created_at)))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }